import { Loader2, RefreshCw, Clock } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface WhatsappQrPanelProps {
  qrBase64:    string | null;
  secondsLeft: number;
  onRetry:     () => void;
  isTimedOut:  boolean;
}

export function WhatsappQrPanel({ qrBase64, secondsLeft, onRetry, isTimedOut }: WhatsappQrPanelProps) {
  const mins = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;

  if (isTimedOut) {
    return (
      <div className="flex flex-col items-center gap-4 rounded-xl border border-[#e8a547]/40 bg-[#e8a547]/10 p-6 text-center">
        <Clock className="h-10 w-10 text-[#e8a547]" />
        <div>
          <p className="font-semibold text-foreground">El código expiró</p>
          <p className="text-sm text-muted-foreground mt-1">El código QR tiene validez de 2 minutos. Genera uno nuevo para continuar.</p>
        </div>
        <Button onClick={onRetry} variant="outline" className="gap-2">
          <RefreshCw className="h-4 w-4" />
          Generar nuevo código
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-4 rounded-xl border border-[#1f5d86]/15 bg-white p-6">
      {/* QR image */}
      <div className="relative flex h-48 w-48 items-center justify-center rounded-xl bg-white shadow-md border">
        {qrBase64 ? (
          <img
            src={qrBase64.startsWith('data:') ? qrBase64 : `data:image/png;base64,${qrBase64}`}
            alt="Código QR de WhatsApp"
            className="h-full w-full rounded-xl object-contain p-1"
          />
        ) : (
          <Loader2 className="h-8 w-8 animate-spin text-[#2980b9]" />
        )}
      </div>

      {/* Instructions */}
      <div className="text-center space-y-1">
        <p className="text-sm font-semibold text-foreground">Escanea con WhatsApp</p>
        <ol className="text-xs text-muted-foreground space-y-0.5 text-left list-decimal list-inside">
          <li>Abre WhatsApp en tu teléfono</li>
          <li>Toca los tres puntos (menu) → Dispositivos vinculados</li>
          <li>Toca "Vincular un dispositivo" y escanea este código</li>
        </ol>
      </div>

      {/* Countdown */}
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Clock className="h-3.5 w-3.5" />
        <span>Código válido por {mins}:{String(secs).padStart(2, '0')}</span>
      </div>
    </div>
  );
}
